/**
 * The one way a clinician is named to a patient: their name as their record
 * carries it, first name then last.
 *
 * The same rule as the server's (blhWebServer
 * src/domain/scheduling/rescheduleEligibility.js `nameOf`: first + last, else
 * `name`), so the reschedule window — which lists the server's names — and
 * the appointment card behind it say the same thing. The card used to put the
 * word "Clinician" in front of the last name, as the title "Dr." once stood
 * there: "Clinician Dr" on the card for the "Miguel Dr" the window offered.
 * A role is not a title; nobody is addressed as "Clinician Patel".
 *
 * The clinician's record wins over the copy an appointment took when it was
 * booked (a name changed since is the current one); the appointment's copy is
 * the fallback for a clinician no longer in the list.
 */

const joined = (...parts) =>
  parts
    .filter((part) => typeof part === "string" && part.trim())
    .map((part) => part.trim())
    .join(" ");

export function clinicianDisplayName({doctor = null, appointment = null, fallback = "Your clinician"} = {}) {
  return (
    joined(doctor?.firstName, doctor?.lastName) ||
    joined(doctor?.name) ||
    joined(appointment?.clinicianFirstName, appointment?.clinicianLastName) ||
    joined(appointment?.dName) ||
    fallback
  );
}
